import { OnInit, Output, EventEmitter, OnDestroy, Directive } from '@angular/core';
import { Subscription } from 'rxjs';

import { FileInfo } from '@classes/file/file-info';
import { FileService } from '@services/file.service';

@Directive()
export class UploadBaseComponent implements OnInit, OnDestroy {
    private processSub: Subscription;

    @Output() afterFilesUpload = new EventEmitter<FileInfo | FileInfo[]>();

    isUploading: boolean;
    isProcessing: boolean;

    constructor(
        protected fileSrv: FileService
    ) {}

    ngOnInit() {
        this.initSubscriptions();
    }

    private initSubscriptions(): void {
        this.processSub = this.fileSrv.processingStateChanged
        .subscribe(processState => {
            this.isProcessing = processState;
        });
    }

    ngOnDestroy() {
        if(this.processSub) {
            this.processSub.unsubscribe();
        }
    }
}
